export const DnDItemTypes = {
  NOTE: 'note',
  SELECTION: 'selection',
}
